// Resolves API + Cognito endpoints at runtime (window.RUNTIME_CONFIG from
// /config.js), with build-time VITE_* fallbacks and localhost defaults.

export interface DeploymentConfig {
  apiUrl: string;
  cognitoDomain: string;
  loginUrl: string;
  clientId: string;
}

export function getDeploymentConfig(): DeploymentConfig {
  const runtime = window.RUNTIME_CONFIG ?? {};
  const env = import.meta.env;
  // The dev server proxies /salvagers-api to the deployed API.
  const defaultApiUrl = "/salvagers-api";
  return {
    apiUrl: runtime.VITE_SALVAGERS_API_BASE_URL || env.VITE_SALVAGERS_API_BASE_URL || defaultApiUrl,
    cognitoDomain: runtime.VITE_COGNITO_DOMAIN || env.VITE_COGNITO_DOMAIN || "",
    loginUrl: runtime.VITE_COGNITO_UI_URL || env.VITE_COGNITO_UI_URL || "https://login.kast-dev.net",
    clientId: runtime.VITE_COGNITO_CLIENT_ID || env.VITE_COGNITO_CLIENT_ID || "",
  };
}
